import { ReactNode, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { ROUTES } from "utils/constants";


interface ComponentProps {
  classes?: {
    header?: string;
    tabs?: string;
    content?: string;
    filter?: string;
    enquiry?: string;
  };
  children: {
    header?: ReactNode;
    tabs?: ReactNode;
    content: ReactNode;
    filter?: ReactNode;
    enquiry?: ReactNode;
  };
}

export default function InnerLayout(props: ComponentProps) {
  const { children, classes = {} } = props;
  const { header, content, filter, tabs, enquiry } = children;
  const location = useLocation();

  return (
    <div className="inner-layout-container">
      {/* Header Section */}
      {header && (
        <div className={`tab-header-container ${classes.header || ""}`}>
          <div className="header-content">{header}</div>
        </div>
      )}

      {/* Tabs Section */}
      {tabs && (
        <div className={`tab-nav-container ${classes.tabs || ""}`}>
          <div className="tabs-scroll-wrapper">{tabs}</div>
        </div>
      )}

      {/* Content Body */}
      <div className={`content-body ${classes.content || ""}`}>
        {/* Main Content */}
        <div className={`content-container ${classes.content || ""}`}>
          {content}
        </div>

        {/* Desktop Filter Sidebar */}
        {filter && (
          <div className={`filter-container desktop-filter ${classes.filter || ""}`}>
            {filter}
          </div>
        )}

        {/* Desktop Enquiry Sidebar */}
        {enquiry && (
          <div className={`enquiry-container desktop-enquiry ${classes.enquiry || ""}`}>
            {enquiry}
          </div>
        )}
      </div>

      {/* Mobile Filter - Rendered outside content-body for proper positioning */}
      {filter && (
        <div className="mobile-filter-wrapper">
          {filter}
        </div>
      )}

      {/* Mobile Enquiry - Rendered outside content-body for proper positioning */}
      {enquiry && (
        <div className="mobile-enquiry-wrapper">
          {enquiry}
        </div>
      )}
    </div>
  );
}